var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "genericFilterModal",
        size: "lg",
        title: `Filter: ${_vm.filter_layer}`,
        "content-class": "filter-modal-content",
        "header-class": "filter-modal-header",
        "body-class": "filter-modal-body",
        "hide-footer": "",
      },
      on: { hidden: _vm.closed },
    },
    [
      _c(
        "div",
        { staticClass: "filter-builder" },
        [
          _c("span", { staticClass: "filter-builder-title" }, [
            _vm._v("Add a filter rule"),
          ]),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "align-items-end no-gutters" },
            [
              _c(
                "b-col",
                { staticClass: "col-sm-4 pr-2" },
                [
                  _c("label", { staticClass: "filter-field-label" }, [
                    _vm._v("Property"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-select",
                    {
                      staticClass: "form-control",
                      class: _vm.missingFields.includes("property")
                        ? "red-border"
                        : "",
                      on: { change: _vm.checkProperty },
                      scopedSlots: _vm._u([
                        {
                          key: "first",
                          fn: function () {
                            return [
                              _c(
                                "b-form-select-option",
                                { attrs: { value: null, disabled: "" } },
                                [
                                  _vm._v(
                                    "\n              Select Property\n            "
                                  ),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.filter.property,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "property", $$v)
                        },
                        expression: "filter.property",
                      },
                    },
                    [
                      _vm._v(" "),
                      _vm._l(_vm.filterValues, function (obj, i) {
                        return _c(
                          "b-form-select-option",
                          { key: i, attrs: { value: obj } },
                          [_vm._v(_vm._s(obj.property))]
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "col-sm-2 pr-2" },
                [
                  _c("label", { staticClass: "filter-field-label" }, [
                    _vm._v("Operator"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-select",
                    {
                      staticClass: "form-control",
                      class: _vm.missingFields.includes("operator")
                        ? "red-border"
                        : "",
                      attrs: {
                        disabled:
                          _vm.filter.property &&
                          _vm.filter.property?.filtervalue?.length > 0,
                      },
                      on: { change: _vm.checkOperator },
                      scopedSlots: _vm._u([
                        {
                          key: "first",
                          fn: function () {
                            return [
                              _c(
                                "b-form-select-option",
                                { attrs: { value: null, disabled: "" } },
                                [
                                  _vm._v(
                                    "\n              Operator\n            "
                                  ),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.filter.operator,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "operator", $$v)
                        },
                        expression: "filter.operator",
                      },
                    },
                    [
                      _vm._v(" "),
                      _vm._l(_vm.operators, function (op) {
                        return _c(
                          "b-form-select-option",
                          { key: op.id, attrs: { value: op.tag } },
                          [
                            _vm._v(
                              "\n            " + _vm._s(op.tag) + "\n          "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.filter.property && _vm.filter.property.filtervalue
                ? _c(
                    "b-col",
                    { staticClass: "col-sm-2 pr-2" },
                    [
                      _c("label", { staticClass: "filter-field-label" }, [
                        _vm._v("Value"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-form-select",
                        {
                          staticClass: "form-control",
                          class: _vm.missingFields.includes("value_1")
                            ? "red-border"
                            : "",
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "first",
                                fn: function () {
                                  return [
                                    _c(
                                      "b-form-select-option",
                                      { attrs: { value: null, disabled: "" } },
                                      [
                                        _vm._v(
                                          "\n              Select Filter Value\n            "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            628068699
                          ),
                          model: {
                            value: _vm.filter.value_1,
                            callback: function ($$v) {
                              _vm.$set(_vm.filter, "value_1", $$v)
                            },
                            expression: "filter.value_1",
                          },
                        },
                        [
                          _vm._v(" "),
                          _vm._l(
                            _vm.filter.property.filtervalue,
                            function (value, i) {
                              return _c(
                                "b-form-select-option",
                                { key: i, attrs: { value: value } },
                                [_vm._v(_vm._s(value))]
                              )
                            }
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _c(
                    "b-col",
                    { staticClass: "col-sm-2 pr-2" },
                    [
                      _c("label", { staticClass: "filter-field-label" }, [
                        _vm._v("Value"),
                      ]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        staticClass: "form-control",
                        class: _vm.missingFields.includes("value_1")
                          ? "red-border"
                          : "",
                        attrs: { placeholder: "Value" },
                        model: {
                          value: _vm.filter.value_1,
                          callback: function ($$v) {
                            _vm.$set(_vm.filter, "value_1", $$v)
                          },
                          expression: "filter.value_1",
                        },
                      }),
                    ],
                    1
                  ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "col-sm-2 pr-2 filter_value_2" },
                [
                  _c(
                    "label",
                    {
                      staticClass: "filter-field-label",
                      class: {
                        invisible:
                          _vm.isHidden || !(_vm.filter && _vm.filter.property),
                      },
                    },
                    [_vm._v("Value 2")]
                  ),
                  _vm._v(" "),
                  _c("b-form-input", {
                    staticClass: "form-control",
                    class: _vm.missingFields.includes("value_2")
                      ? "red-border"
                      : "",
                    attrs: {
                      placeholder: "Value",
                      hidden:
                        _vm.isHidden || !(_vm.filter && _vm.filter.property),
                    },
                    model: {
                      value: _vm.filter.value_2,
                      callback: function ($$v) {
                        _vm.$set(_vm.filter, "value_2", $$v)
                      },
                      expression: "filter.value_2",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "col-sm-2 filter-actions" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "filter-btn filter-add-btn",
                      on: {
                        click: function ($event) {
                          return _vm.addRule()
                        },
                      },
                    },
                    [_vm._v("\n          Apply Filter\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.rules.filter((r) => r.layer == _vm.filter_layer).length
        ? _c("div", { staticClass: "active-rules" }, [
            _c("span", { staticClass: "active-rules-title" }, [
              _vm._v("Active rules"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "rule-chips" },
              _vm._l(
                _vm.rules.filter((r) => r.layer == _vm.filter_layer),
                function (rule, index) {
                  return _c(
                    "span",
                    { key: index, staticClass: "rule-chip" },
                    [
                      _c("span", { staticClass: "rule-chip-prop" }, [
                        _vm._v(_vm._s(rule.property)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "rule-chip-op" }, [
                        _vm._v(_vm._s(rule.operator)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "rule-chip-val" },
                        [
                          _vm._v("\n          " + _vm._s(rule.value_1)),
                          rule.value_2 != null
                            ? [_vm._v(" – " + _vm._s(rule.value_2))]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("fa", {
                        staticClass: "rule-chip-remove",
                        attrs: { icon: ["fas", "times"] },
                        on: {
                          click: function ($event) {
                            return _vm.removeRule(index)
                          },
                        },
                      }),
                    ],
                    1
                  )
                }
              ),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter-options" },
        [
          _c(
            "p",
            { staticClass: "filter-hint" },
            [
              _c("fa", {
                staticClass: "mr-1",
                attrs: { icon: ["fas", "info-circle"] },
              }),
              _vm._v(
                "\n      Use dropdowns to create a filter for the layer. Press "
              ),
              _c("strong", [_vm._v("Add Rule")]),
              _vm._v(" to add it to the layer.\n    "),
            ],
            1
          ),
          _vm._v(" "),
          _vm.rules.filter((r) => r.layer == _vm.filter_layer).length
            ? _c(
                "b-button",
                {
                  staticClass: "filter-btn filter-clear-btn",
                  attrs: { variant: "outline-danger" },
                  on: { click: _vm.removeFilter },
                },
                [_vm._v("\n          Clear All Filters\n        ")]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }